import React, { useEffect, useState } from 'react';
import { Loader } from '../../../Common/Loader/loader';
import { classesDashboardSx as styles } from './styles';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../Infrastructure/config';
import { ClassItem } from '../../../Common/ClassItem/classItem';
import { ClassDetailPage } from './ClassDetailPage/classDetailPage';
import { ShowSuccessToast } from '../../../Common/Toast/toast';
import { Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ERROR_CONSTANTS from '../../../../Infrastructure/Constants/errorConstants';
import useAuthentication from '../../../../Infrastructure/States/onAuthStateChange';
import { showErrorModal } from '../../../../Infrastructure/States/errorModalSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import paths from '../../../../Infrastructure/Router/paths';
import { USER_LOGS_CLIENT } from '../../../../Infrastructure/Constants/logsConstant';
import { safeClientLogEvent } from '../../../../Infrastructure/Utilities/safeClientLogEvent';
import useServerClock from '../../../../Infrastructure/CustomHooks/useServerClock';

export const ClassesStudentDashboard = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const serverNow = useServerClock()
  const {userId} = useAuthentication()
  const [tab, setTab] = useState("active");
  const [open, setOpen] = React.useState(false);
  const ip = useSelector((state) => state.ip.address)
  const [selectedClass, setSelectedClass] = useState(null);
  const [refundLoading, setRefundLoading] = useState(false);
  const page = useSelector((state)=> state.route.currentRoute)
  const userData = useSelector((state) => state.userData.data);
  const [refundingClassData, setRefundingClassData] = useState(null);
  const [enrolledPastClasses, setEnrolledPastClasses] = useState([]);
  const [showClassDetailPage, setShowClassDetailPage] = useState(false);
  const [enrolledActiveClasses, setEnrolledActiveClasses] = useState([]);
  const [enrolledUpComingClasses, setEnrolledUpComingClasses] = useState([]);
  const [enrolledClassesLoading, setEnrolledClassesLoading] = useState(false);

  const handleClassItemClick = (classData) => {
    setSelectedClass(classData);
    setShowClassDetailPage(true);
  }

  const handleBackToList = () => {
    setShowClassDetailPage(false);
    setSelectedClass(null);
  }

  const handleRefund = async () => {
    try {
      setRefundLoading(true);
      const refundCourse = httpsCallable(functions, "refundcourse");
      const res = await refundCourse({ classId: refundingClassData.classId, courseId: refundingClassData.courseId, educatorId: refundingClassData.educatorId, ip, page });
      if (res?.data?.isSuccess) {
        ShowSuccessToast("Refund Successful");
      } else {
        dispatch(showErrorModal({  errorMessage: ERROR_CONSTANTS.COURSE_REFUND_ERROR_MODAL.MESSAGE}))
      }
    } catch (error) {
      dispatch(
        showErrorModal({
          errorMessage: ERROR_CONSTANTS.COURSE_REFUND_ERROR_MODAL.MESSAGE
        })
      );
      await safeClientLogEvent({
        ...USER_LOGS_CLIENT.REFUND_ERROR,
        uid: userId,
        source: "educatorProfileStep.jsx",
        emailInfo: null,
        metadata: null,
        error: error?.message || null
      });
    } finally {
      handleClose();
      setRefundLoading(false);
    }
  };

  const getClassCount = (classes) => classes.length;

  const handleClassRefunding = (classId, courseId, educatorId) => {
    setOpen(true)
    setRefundingClassData({classId, courseId, educatorId})
  };

  const handleClose = () => setOpen(false);

  const fetchClasses = async () => {
    if (userData && userData.student && userData.student.classes) {
      const pastClasses = [];
      const activeClasses = [];
      const futureClasses = [];

      Object.values(userData?.student?.classes).forEach((classData) => {
        const firstClassTime = classData.first_class; // Already in seconds
        const lastClassTime = classData.last_class; // Already in seconds

        if (classData.payment_status === "pending" || classData.payment_status === "success") {
          if (lastClassTime < serverNow) {
            pastClasses.push(classData);
          } else if (firstClassTime > serverNow) {
            futureClasses.push(classData);
          } else if (firstClassTime <= serverNow && lastClassTime >= serverNow) {
            activeClasses.push(classData);
          }
        }else if (classData.payment_status === "failed" && ( firstClassTime > serverNow )) {
          futureClasses.push(classData);
        }
      });

      setEnrolledPastClasses(pastClasses)
      setEnrolledActiveClasses(activeClasses)
      setEnrolledUpComingClasses(futureClasses)
    }
    setEnrolledClassesLoading(false);
  }

  const handleTryAgainPayment = (classData) => {
    navigate(paths.checkoutPage.path, { state: { educator_id: classData?.educator_id, course_id: classData?.course_id, classId: classData?.class_id } });
  };
  useEffect(() => {
    const tabCounts = {
      active: enrolledActiveClasses.length,
      upcoming: enrolledUpComingClasses.length,
      past: enrolledPastClasses.length,
    };
    // If current tab still has data, do nothing
    if (tabCounts[tab] > 0) return;
    // Otherwise select first available tab
    const firstAvailable = Object.entries(tabCounts)
      .find(([_, count]) => count > 0);
    if (firstAvailable) {
      setTab(firstAvailable[0]);
    }
  }, [
    enrolledPastClasses,
    enrolledActiveClasses,
    enrolledUpComingClasses,
    tab
  ])

  useEffect(() => {
    if (!serverNow || !userData) return;    
    setEnrolledClassesLoading(true);
    fetchClasses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverNow, userData]);

  useEffect(() => {
    setShowClassDetailPage(false);
  }, [location.pathname, location.hash])
  return (
    <Box>
      <Modal
        aria-labelledby="refund-modal-title"
        aria-describedby="refund-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={styles.refundModalBox}>
            <Typography id="refund-modal-title" variant="h6" component="h2">
              Are you sure you want to cancel?
            </Typography>
            <Typography id="refund-modal-description" sx={styles.modalDescription}>
              You will receive a full refund.
            </Typography>
            {refundLoading ? (
              <Box sx={styles.loaderBox}>
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={styles.modalButtonsWrapper}>
                <Button variant="contained" sx={styles.buttonNo} onClick={handleClose}>
                  No
                </Button>
                <Button variant="contained" sx={styles.buttonYes} onClick={handleRefund}>
                  Yes
                </Button>
              </Box>
            )}
          </Box>
        </Fade>
      </Modal>

      <Box sx={styles.pageWrapper}>
        {showClassDetailPage ? (
          <ClassDetailPage classData={selectedClass} handleBackToList={handleBackToList} />
        ) : (
          <>
            <Box sx={styles.classHeaderBox}>
              <Typography variant='h1'>Classes</Typography>
            </Box>
            {
              enrolledClassesLoading ?
                <Box height={'80vh'}><Loader /></Box>
                :
                <Box width="100%">
                  <Box sx={styles.classTabBox}>
                    {['active', 'upcoming', 'past'].map((type) => {
                      const count = type === 'active'
                        ? getClassCount(enrolledActiveClasses)
                        : type === 'upcoming'
                          ? getClassCount(enrolledUpComingClasses)
                          : getClassCount(enrolledPastClasses);
                      if (count === 0) return null
                      return (
                        <Box key={type} mb={{ xs:4, sm:0 }} display={'flex'} alignItems={'center'} mx={2} sx={styles.tabItem}>
                          <Typography
                            color={tab === type ? "primary" : "inherit"}
                            sx={styles.tabTypography(tab === type)}
                            onClick={() => setTab(type.toLowerCase())}
                          >
                            {type.toUpperCase()}
                          </Typography>

                          {count > 0 && (
                            <Box sx={styles.tabCountBadge}>
                              <Typography variant="caption" sx={styles.tabCountText}>
                                {count}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                  <Box sx={styles.classContainer}>
                    {tab === 'active' && (
                      <Box sx={styles.classListWrapper}>
                        {enrolledActiveClasses.length > 0 ? (
                          enrolledActiveClasses.map((classData, index) => (
                            <ClassItem
                              key={index}
                              serverNow={serverNow}
                              classData={classData}
                              handleRefund={(data) => handleClassRefunding(data.classId, data.courseId, data.educatorId)}
                              onClick={() => handleClassItemClick(classData)}
                            />
                          ))
                        ) : (
                          <Typography>No active classes</Typography>
                        )}
                      </Box>
                    )}
                    {tab === 'upcoming' && (
                      <Box sx={styles.classListWrapper}>
                        {enrolledUpComingClasses.length > 0 ? (
                          enrolledUpComingClasses.map((classData, index) => (
                            <ClassItem
                              key={index}
                              classData={classData}
                              serverNow={serverNow}
                              onClick={() => handleClassItemClick(classData)}
                              handleTryAgainPayment={() => handleTryAgainPayment(classData)}
                              handleRefund={(data) => handleClassRefunding(data.classId, data.courseId, data.educatorId)}
                            />
                          ))
                        ) : (
                          <Typography>No upcoming classes</Typography>
                        )}
                      </Box>
                    )}
                    {tab === 'past' && (
                      <Box sx={styles.classListWrapper}>
                        {enrolledPastClasses.length > 0 ? (
                          enrolledPastClasses.map((classData, index) => (
                            <ClassItem
                              key={index}
                              classData={classData}
                              serverNow={serverNow}
                              handleRefund={(data) => handleClassRefunding(data.classId, data.courseId, data.educatorId)}
                              onClick={() => handleClassItemClick(classData)}
                              handleTryAgainPayment={() => handleTryAgainPayment(classData)}
                            />
                          ))
                        ) : (
                          <Typography>No past classes</Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
            }
          </>
        )}
      </Box>
    </Box>
  );
};
